import API from '@/lib/API.js'
import comun from './comun.js'
const tipodocumentacionestipoafiliacion = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getTipo_documentaciones_tipo_afiliacion();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Tipo_documentaciones_tipo_afiliacion.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let entidad = state.Lista.find((x) => x.id_tipo_documentaciones_tipo_afiliacion == payload)
            commit("select", entidad)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let entidad = {
                id_tipo_documentaciones_tipo_afiliacion: 0,
                id_tipo_documentaciones: 0,
                id_tipo_afiliacion: 0,
                Obligatorio: false,
            }
            commit("select", entidad)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (state.Seleccionado.id_tipo_documentaciones_tipo_afiliacion != 0) {
                data = await API.Tipo_documentaciones_tipo_afiliacion.modificar(state.Seleccionado);
                str += "Tipo documentaciones x tipo afiliacion modificada"
            } else {
                data = await API.Tipo_documentaciones_tipo_afiliacion.alta(state.Seleccionado);
                str += `Nuevo Tipo documentaciones x tipo afiliacion de alta`
            }
            let secs = await API.Tipo_documentaciones_tipo_afiliacion.traerTodos();
            commit("set", secs)
            //commit("select", data)
            dispatch("selectPorId", data.id_tipo_documentaciones_tipo_afiliacion)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
    },
    getters: {
        getTipo_documentaciones_tipo_afiliacion: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default tipodocumentacionestipoafiliacion;